/* eslint-disable max-len */
import { RootState } from 'interfaces';
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/groups/update'] || initialState;

export const selectGroup = createSelector([selectDomain], (GroupUpdateState) => GroupUpdateState.group);
export const selectSponsorContent = createSelector([selectDomain], (GroupUpdateState) => GroupUpdateState.group.sponsorContent);
export const selectGroupUpdateLoading = createSelector([selectDomain], (GroupUpdateState) => GroupUpdateState.loading);
export const selectExpertResult = createSelector([selectDomain], (GroupUpdateState) => GroupUpdateState.expertResult);
export const selectExperts = createSelector([selectDomain], (GroupUpdateState) => GroupUpdateState.group.experts);
export const selectSessions = createSelector([selectDomain], (GroupUpdateState) => GroupUpdateState.group.sessions);
export const selectArticles = createSelector([selectDomain], (GroupUpdateState) => GroupUpdateState.group.articles);
export const selectContentOnlySessions = createSelector([selectDomain], (GroupUpdateState) => GroupUpdateState.group.content);
export const selectUsers = createSelector([selectDomain], (GroupUpdateState) => GroupUpdateState.users);
